<template>
  <span class="svg-icon-more">
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.75 8.72317V6.91298C4.75 5.6902 5.74501 4.69519 6.96779 4.69519H22.4563C23.6791 4.69519 24.6741 5.6902 24.6741 6.91298V8.72317" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.7124 23.3127V5.59436" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10.6362 23.3126H17.3256" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.7642 14.01H27.1678C28.0429 14.01 28.7502 14.7173 28.7502 15.5924V16.5515" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M21.6411 27.3048V14.6454" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M19.0757 27.3044H24.2066" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 32 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#fff' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>